var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { useClipboard } from 'use-clipboard-copy';
import { Link } from '../Link/index.js';
import { FormControl } from './FormControl.js';
export const FormControlInputCopy = props => {
    const { value, hidden = false } = props, rest = __rest(props, ["value", "hidden"]);
    const [copied, setCopied] = useState(false);
    const clipboard = useClipboard();
    const [showValue, setShowValue] = useState(!hidden);
    const addon = hidden ? (React.createElement("div", { className: "flex items-center h-full pr-2" },
        React.createElement(Link, { onClick: () => setShowValue(!showValue), variant: "neutral" }, showValue ? 'Hide' : 'Show'))) : null;
    return (React.createElement(FormControl.Input, Object.assign({}, rest, { value: value, onClick: e => e.currentTarget.select(), type: showValue ? 'text' : 'password', trailingAddon: React.createElement("div", { className: "flex h-full divide-x divide-basicSurface-300/25" },
            addon,
            React.createElement("div", { className: clsx('flex items-center h-full', !!addon && 'pl-2') },
                React.createElement(Link, { onClick: () => {
                        clipboard.copy(value);
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    }, variant: "neutral" }, copied ? 'Copied' : 'Copy'))) })));
};
//# sourceMappingURL=FormControlInputCopy.js.map